import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TemplateProfilo } from '../../../models/profili-utente/template-profilo';
import { TemplateUtenteProfilo } from '../../../models/profili-utente/template-utente-profilo';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [autorizzazioni-view]',
  templateUrl: 'autorizzazioni-view.component.html'
})

export class AutorizzazioniViewComponent {

  @Input() template: TemplateUtenteProfilo;
  @Input() i: number;
  @Input() disableModifica: boolean;
  @Output() modalUpdate: EventEmitter<TemplateUtenteProfilo > = new EventEmitter();

openModalUpdate(templateUtente: TemplateUtenteProfilo) {
  this.modalUpdate.emit(templateUtente);
}

  private elementInArray(idElement: string, list: TemplateProfilo[]): boolean {
    let result: boolean = false;
    for (let template of list) {
      if (template.id === idElement) {
        result = true;
        break;
      }
    }
    return result;
  }

  estraiNomeGruppo(idGruppo: string): string {
    if (!idGruppo) return '';
    // Rimuovo prefisso "GRP_TR_" se presente
    let nomePulito = idGruppo.replace(/^GRP_TR_/, '');
    // Sostituisco i separatori "|" con spazi
    nomePulito = nomePulito.replace(/\|/g, ' ');
    return nomePulito;
  }

  get gruppiPermessiOrdinati() {
    if (!this.template?.permessiPerGruppoOrganizzativo) return [];
      return [...this.template.permessiPerGruppoOrganizzativo].sort((a, b) => {
        const nomeA = this.estraiNomeGruppo(a.idGruppo).toLowerCase();
        const nomeB = this.estraiNomeGruppo(b.idGruppo).toLowerCase();
        return nomeA.localeCompare(nomeB);
      });
  }

}
